export class ProduktLinie {
  jaehrlich = 0;
  halbjaehrlich = 0;
  vierteljaehrlich = 0;
  monatlich = 0;
  einmalig = 0;
  gemZahlungsweise = 0;
  nameProduktLinie = "";
  produktLinienIndex = 0;
  jaehrlichNetto = 0;
  jaehrlichNettoHalbjaehrlich = 0;
  jaehrlichNettoVierteljaehrlich = 0;
  jaehrlichNettoMonatlich = 0;
  gemZahlungsweiseJaehrlichNetto = 0;
  jaehrlichBrutto = 0;
  jaehrlichBruttoHalbjaehrlich = 0;
  jaehrlichBruttoVierteljaehrlich = 0;
  jaehrlichBruttoMonatlich = 0;
  gemZahlungsweiseJaehrlichBrutto = 0;
  halbjaehrlichNetto = 0;
  vierteljaehrlichNetto = 0;
  monatlichNetto = 0;
  einmaligNetto = 0;
  gemZahlungsweiseNetto = 0;
  steuersatz = 0;
  jaehrlichSteuerbetrag = 0;
  halbjaehrlichSteuerbetrag = 0;
  vierteljaehrlichSteuerbetrag = 0;
  monatlichSteuerbetrag = 0;
  einmaligSteuerbetrag = 0;
  gemZahlungsweiseSteuerbetrag = 0;
  //klauseln: Klausel[];
  produktPmId = "";
  produktbausteinId = "";
}
